import React from "react";
import {
    Button,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    UncontrolledDropdown
} from "reactstrap";
import {Link, Redirect} from "react-router-dom";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import {report_strings} from "../../translations/report_translations";
import {isMobile} from "react-device-detect";
import browserSvg from "assets/img/icons/common/browser.svg"

let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);
let commonStrings = new LocalizedStrings(common_strings);

class ScheduleHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.setState({isLoading: true});

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
        }
    }

    render() {
        this.localize();

        return (
            <>
                <div className="header"
                     style={{
                         height: "240px",
                         maxHeight: "20px important!",
                         backgroundImage: "url(" + require("assets/img/theme/stats_back.jpg") + ")",
                         backgroundSize: "cover",
                         backgroundPosition: "bottom"
                     }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-7"/>

                    <Container className="d-flex align-items-center" fluid>
                        {/*{!isMobile &&*/}

                        <div style={{width: "100%"}}>
                            <Row style={{marginTop: 100, width: "100%", display: "block", marginLeft: 20}}>
                                {!isMobile &&
                                    <>
                                        <Button
                                            color="secondary"
                                            size="sm"
                                            slyles={{marginTop: "10px", float: "right"}}
                                            onClick={e => this.props.weekView(e)}
                                        >
                                            <span className="fas fa-calendar-week"/> {commonStrings.week}
                                        </Button>
                                        <Button
                                            color="secondary"
                                            size="sm"
                                            slyles={{marginTop: "10px", float: "right"}}
                                            onClick={e => this.props.monthView(e)}
                                        >
                                            <span className="fas fa-calendar-alt"/> {commonStrings.month}
                                        </Button>
                                    </>
                                }

                            </Row>
                            <div className="d-none d-md-block" style={{width: "100%", display: "flex", flexFlow: "row", alignItems: "center", justifyContent: "space-between"}}>
                                <span style={{
                                    marginLeft: 20,
                                    marginTop: 10,
                                    display: "flex",
                                    flexFlow: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-start"
                                }}>
                                <Button
                                    size="lg"
                                    color="danger"
                                    slyles={{marginTop: "10px"}}
                                    onClick={e => this.addClasses(e)}
                                >
                                    {resourceStrings.add_delete_classes}
                                </Button>
                                <Button
                                    size="lg"
                                    color="warning"
                                    slyles={{marginTop: "10px"}}
                                    onClick={e => this.props.addClass(e)}
                                >
                                    {resourceStrings.add_class}
                                </Button>

                                <Button
                                    size="lg"
                                    color="secondary"
                                    slyles={{marginTop: "10px"}}
                                    onClick={e => this.props.showCopyClasses(e)}
                                >
                                    <i style={{marginRight: 8}} className="fas fa-copy"/>
                                    {commonStrings.copy}
                                </Button>
                                </span>

                                <span style={{
                                    marginBottom: 20,
                                    display: "flex",
                                    flexFlow: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-end"
                                }}>

                                    <Button
                                        size="sm"
                                        color={this.props.filtersAreOn ? "danger" : "info"}
                                        slyles={{marginTop: "10px"}}
                                        onClick={e => this.props.showFilters(e)}
                                    >
                                        <i style={{color: "white", marginRight: 8}} className="fas fa-filter"/>
                                        {reportStrings.filter}
                                    </Button>

                                    <Button
                                        size="sm"
                                        color="primary"
                                        slyles={{marginTop: 10}}
                                        onClick={e => this.props.addReminder(e)}
                                    >
                                        {resourceStrings.events.add_reminder}
                                    </Button>

                                    <Button
                                        size="sm"
                                        color="success"
                                        slyles={{marginTop: "10px"}}
                                        onClick={e => this.props.showWidget(e)}
                                    >
                                        {resourceStrings.schedule_widget}
                                    </Button>

                                    </span>

                            </div>
                        </div>
                        {/*}*/}
                        {/*{isMobile &&*/}
                        <span className="d-md-none">
                            {this.renderScheduleMobileMenu()}
                        </span>
                        {/*}*/}

                    </Container>
                </div>
            </>
        );
    }

    renderScheduleMobileMenu() {
        return <Row style={{marginTop: "5rem", marginRight: 10}}>
            <UncontrolledDropdown nav>
                <DropdownToggle className="pr-0" nav>
                    <Button
                        color="info"
                        href="#"
                        onClick={e => e.preventDefault()}
                    >
                        {commonStrings.navigation.add_delete}
                    </Button>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow bg-default" right>
                    <DropdownItem className="noti-title" header tag="div">
                        <h6 className="text-overflow m-0"></h6>
                    </DropdownItem>
                    <DropdownItem onClick={e => this.addClasses(e)} tag={Link}>

                        <span className="text-white">{resourceStrings.add_delete_classes}</span>
                    </DropdownItem>

                    <DropdownItem onClick={e => this.props.addClass(e)} tag={Link}>
                        <span className="text-white">{resourceStrings.add_class}</span>
                    </DropdownItem>

                    <DropdownItem onClick={e => this.props.addEvent(e)} tag={Link}>
                        <span className="text-white">{resourceStrings.events.add_event}</span>
                    </DropdownItem>

                    <DropdownItem onClick={e => this.props.addReminder(e)} tag={Link}>
                        <span className="text-white">{resourceStrings.events.add_reminder}</span>
                    </DropdownItem>

                    <DropdownItem onClick={e => this.props.showCopyClasses(e)} tag={Link}>
                        <span className="text-white">{commonStrings.copy}</span>
                    </DropdownItem>

                    <DropdownItem divider/>
                    <DropdownItem href="#pablo" onClick={e => this.props.showFilters(e)}>
                        <span className="text-white">{reportStrings.filter}</span>
                    </DropdownItem>

                    <DropdownItem href="#pablo" onClick={e => this.props.showWidget(e)}>
                        <span className="text-white">{resourceStrings.schedule_widget}</span>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </Row>
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        reportStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        // studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

    addClasses(e) {
        e.preventDefault();
        this.props.addRegClasses()
    }
}

export default ScheduleHeader;
